import React, { useState } from 'react';
import logo from './../assets/brand-logo.png';
import {GiHamburgerMenu} from 'react-icons/gi';

const Navbar = () => {
    const [ showMenu, setShowMenu] = useState(false);
  return (
    <nav>
     <nav className="w-full main-nav grid font-['Mulish']">
        <div className='navbar-logo grid justify-start items-center'>
            <img src={logo} alt='logo' />
        </div>

        <div className={ showMenu ? 'mobile-menu' : 'navbar-links' }>
            <ul>
                <li><a href='#home'>Home</a></li>
                <li><a href='#Product'>Product</a></li>
                <li><a href='#howItWorks'>How It Works</a></li>
                <li><a href='#pricing'>Pricing</a></li>
                <li><a href='#Resources'>Resources</a></li>
            </ul>
        </div>

        <div className='button-container'>
            <ul className=''>
                <li className="bg-[#1B1139] font-medium py-3 px-7 text-white m-5 text-sm font-['Mulish'] "><a href='login'>Login</a></li>
                <li className="bg-[#52BD95]  font-['Mulish'] font-medium text-sm text-white py-3 px-7"><a href='#trial' >Start Your 15-Day Trial</a></li>
            </ul>
            <div className='hamburger-menu'>
                 <a href='#menu' onClick={() => setShowMenu(!showMenu)}><GiHamburgerMenu /></a>
            </div>
        </div>
    </nav> 


    </nav>
  )
}

export default Navbar